window.dpdParcelShopWidget = (function () {
	var mapWidgetPopupSelector,
		popup,
		dpdMapWidget,
		mapWidgetPopupContainerSelector,
		mapWidgetPopupOpenBtnSelector,
		chosenParcelShopContentSelector,
		chosenParcelShopContentTextSelector,
		chosenParcelShopHiddenParcelIdSelector,
		chosenParcelShopHiddenParcelPusIdSelector,
		chosenParcelShopHiddenParcelNameSelector,
		chosenParcelShopHiddenParcelStreetSelector,
		chosenParcelShopHiddenParcelCitySelector,
		chosenParcelShopHiddenParcelZipSelector,
		chosenParcelShopHiddenParcelCountryCodeSelector,
		dpdMapWidgetEl,
		customerZip,
		countries,
		baseCountryCode,
		isMapInitialized = false;

	function init() {
		mapWidgetPopupOpenBtnSelector =
			'.js-dpd-parcelshop-map-widget-open-popup-btn';

		mapWidgetPopupSelector = '.js-dpd-parcelshop-map-widget-popup';

		mapWidgetPopupContainerSelector =
			'.js-dpd-parcelshop-map-widget-popup-container';

		chosenParcelShopContentSelector = '.js-dpd-chosen-parcelshop-content';
		chosenParcelShopContentTextSelector =
			'.js-dpd-chosen-parcelshop-chosen-parcelshop-text';
		chosenParcelShopHiddenParcelIdSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-id';
		chosenParcelShopHiddenParcelPusIdSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-pus-id';
		chosenParcelShopHiddenParcelNameSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-name';
		chosenParcelShopHiddenParcelStreetSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-street';
		chosenParcelShopHiddenParcelCitySelector =
			'.js-dpd-parcelshop-hidden-parcelshop-city';
		chosenParcelShopHiddenParcelZipSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-zip';
		chosenParcelShopHiddenParcelCountryCodeSelector =
			'.js-dpd-parcelshop-hidden-parcelshop-country-code';

		popup = document.querySelector(mapWidgetPopupSelector);

		/**
		 * Open the popup when the user clicks the open button
		 */
		document.addEventListener(
			'click',
			function (event) {
				if (!event.target.matches(mapWidgetPopupOpenBtnSelector)) {
					return;
				}

				event.preventDefault();

				// Fetch the dpdMapWidgetEl element dynamically
				dpdMapWidgetEl = document.querySelector(
					'.js-dpd-parcelshop-map-widget-popup-embed'
				);

				if (!dpdMapWidgetEl) {
					return;
				}

				// Fetch the dpdMapOpenWidgetMapPopupEl element dynamically
				dpdMapOpenWidgetMapPopupEl = event.target.closest(
					mapWidgetPopupOpenBtnSelector
				);

				if (!dpdMapOpenWidgetMapPopupEl) {
					return;
				}

				initMap();
				openPopup();
			},
			false
		);

		/**
		 * Close the popup when the user clicks outside of it
		 */
		document.addEventListener(
			'click',
			function (event) {
				if (!event.target.matches(mapWidgetPopupContainerSelector)) {
					return;
				}

				event.preventDefault();

				closePopup();
			},
			false
		);

		/**
		 * Close the popup when the escape key is pressed
		 */
		document.addEventListener(
			'keydown',
			function (event) {
				if (event.key !== 'Escape') {
					return;
				}

				closePopup();
			},
			false
		);

		/**
		 * Trigger the update_checkout event when the payment method is changed and a parcel shop is chosen
		 */
		document.addEventListener(
			'change',
			function (event) {
				if (
					event.target &&
					event.target.matches('input[name="payment_method"]')
				) {
					// Check if a parcel shop is chosen
					if (isParcelShopChosen()) {
						// Trigger the update_checkout event
						document.body.dispatchEvent(new Event('update_checkout'));
					}
				}
			},
			false
		);
	}

	/**
	 * Initialize the map
	 */
	function initMap() {
		if (isMapInitialized) {
			return;
		}

		const apiKey = dpdMapWidgetEl.getAttribute('data-api-key');
		const language = dpdMapWidgetEl.getAttribute('data-language') || 'sk';

		if (!apiKey) {
			console.log('Map Api key is missing');
			return;
		}

		countries = JSON.parse(
			dpdMapOpenWidgetMapPopupEl.getAttribute('data-countries')
		);
		allowedCountries = JSON.parse(
			dpdMapOpenWidgetMapPopupEl.getAttribute('data-allowed-countries')
		);
		allowedCountries = allowedCountries.join(',');
		baseCountryCode = dpdMapOpenWidgetMapPopupEl.getAttribute(
			'data-base-country-code'
		);

		dpdMapWidget = new DpdPudo.Widget({
			apiKey: apiKey,
			country: baseCountryCode,
			allowedCountries: [allowedCountries],
			language: language,
		});

		isMapInitialized = true;
	}

	/**
	 * Set the selected parcel shop in the session and update the frontend field
	 */
	function setSelectedParcelShop(data = {}) {
		if (!data || Object.keys(data).length === 0) {
			return;
		}

		const parcelShopId = data.hasOwnProperty('id') ? data.id : null;
		const parcelShopPusId = data.hasOwnProperty('id') ? data.id : null;
		const parcelShopName = data.hasOwnProperty('name') ? data.name : null;
		const parcelShopStreet = data.hasOwnProperty('street') ? data.street : null;
		const parcelShopZip = data.hasOwnProperty('zip') ? data.zip : null;
		const parcelShopCity = data.hasOwnProperty('city') ? data.city : null;
		const parcelShopCountryCode = data.hasOwnProperty('countryCode')
			? data.countryCode
			: null;
		const parcelShopMaxWeight = data.hasOwnProperty('maxweight')
			? data.maxweight
			: null;
		const parcelShopCod = data.hasOwnProperty('cod') ? data.cod : null;
		const parcelShopCard = data.hasOwnProperty('card') ? data.card : null;
		const isEligibleForAlzabox = data.hasOwnProperty('isEligibleForAlzabox')
			? data.isEligibleForAlzabox
			: null;
		const isEligibleForSlovenskaPostaBox = data.hasOwnProperty(
			'isEligibleForSlovenskaPostaBox'
		)
			? data.isEligibleForSlovenskaPostaBox
			: null;

		// Update session
		setSelectedParcelShopSession(
			parcelShopId,
			parcelShopPusId,
			parcelShopName,
			parcelShopStreet,
			parcelShopZip,
			parcelShopCity,
			parcelShopCountryCode,
			parcelShopMaxWeight,
			parcelShopCod,
			parcelShopCard,
			isEligibleForAlzabox,
			isEligibleForSlovenskaPostaBox
		);

		const parcelShopCountry =
			countries &&
			typeof countries === 'object' &&
			countries.hasOwnProperty(parcelShopCountryCode)
				? countries[parcelShopCountryCode]
				: parcelShopCountryCode;

		// Update frontend field
		document.querySelector(chosenParcelShopHiddenParcelIdSelector).value =
			parcelShopId;
		document.querySelector(chosenParcelShopHiddenParcelPusIdSelector).value =
			parcelShopPusId;
		document.querySelector(chosenParcelShopHiddenParcelNameSelector).value =
			parcelShopName;
		document.querySelector(chosenParcelShopHiddenParcelStreetSelector).value =
			parcelShopStreet;
		document.querySelector(chosenParcelShopHiddenParcelZipSelector).value =
			parcelShopZip;
		document.querySelector(chosenParcelShopHiddenParcelCitySelector).value =
			parcelShopCity;
		document.querySelector(
			chosenParcelShopHiddenParcelCountryCodeSelector
		).value = parcelShopCountryCode;

		// Filter out empty values
		const notEmptyAddressValues = Object.values([
			parcelShopName,
			parcelShopStreet,
			parcelShopZip,
			parcelShopCity,
			parcelShopCountry,
		]).filter((value) => !!value);

		// Construct the text content
		document.querySelector(chosenParcelShopContentTextSelector).innerHTML =
			notEmptyAddressValues.join(', ');

		document
			.querySelector(chosenParcelShopContentSelector)
			.classList.add('active');
	}

	/**
	 * Set the selected parcel shop in the session
	 */
	function setSelectedParcelShopSession(
		parcelShopId = '',
		parcelShopPusId = '',
		parcelShopName = '',
		parcelShopStreet = '',
		parcelShopZip = '',
		parcelShopCity = '',
		parcelShopCountryCode = '',
		parcelShopMaxWeight = '',
		parcelShopCod = '',
		parcelShopCard = '',
		isEligibleForAlzabox = true,
		isEligibleForSlovenskaPostaBox = true
	) {
		// Prepare XHR Request.
		var xhr = new XMLHttpRequest();
		xhr.open('POST', wc_dpd_parcelshop_map_widget_settings.ajax_url, true);
		xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

		// Callback on response.
		xhr.onreadystatechange = function () {
			// readyState 4 means the request is done.
			var DONE = 4;

			// status 200 is a successful return.
			var OK = 200;

			// Check response.
			if (xhr.readyState === DONE) {
				if (xhr.status === OK) {
					document.body.dispatchEvent(new Event('update_checkout'));
				}
			}
		};

		// Finally do the call with the right parametetrs.
		xhr.send(
			'action=wc_dpd_update_chosen_parcelshop&wp_nonce=' +
				popup.getAttribute('data-nonce') +
				'&wc_dpd_parcelshop_id=' +
				parcelShopId +
				'&wc_dpd_parcelshop_pus_id=' +
				parcelShopPusId +
				'&wc_dpd_parcelshop_name=' +
				parcelShopName +
				'&wc_dpd_parcelshop_street=' +
				parcelShopStreet +
				'&wc_dpd_parcelshop_zip=' +
				parcelShopZip +
				'&wc_dpd_parcelshop_city=' +
				parcelShopCity +
				'&wc_dpd_parcelshop_country_code=' +
				parcelShopCountryCode +
				'&wc_dpd_parcelshop_max_weight=' +
				parcelShopMaxWeight +
				'&wc_dpd_parcelshop_cod=' +
				parcelShopCod +
				'&wc_dpd_parcelshop_card=' +
				parcelShopCard +
				'&wc_dpd_parcelshop_is_alzabox_eligible=' +
				isEligibleForAlzabox +
				'&wc_dpd_parcelshop_is_slovenska_posta_eligible=' +
				isEligibleForSlovenskaPostaBox
		);
	}

	/**
	 * Open the popup
	 */
	function openPopup() {
		popup.classList.add('active');

		if (dpdMapWidgetEl && dpdMapWidget) {
			const chosenParcelShopId = document.querySelector(
				chosenParcelShopHiddenParcelIdSelector
			).value;

			if (chosenParcelShopId) {
				dpdMapWidget.options.selectedPudoId = chosenParcelShopId;
			}

			// Reselect open button to get refreshed data
			dpdMapOpenWidgetMapPopupEl = document.querySelector(
				mapWidgetPopupOpenBtnSelector
			);

			// Add zip if available
			customerZip = getCustomerZip();

			if (customerZip) {
				dpdMapWidget.options.zip = customerZip;
			}

			// Get the selected customer country
			const countryCode = dpdMapOpenWidgetMapPopupEl.getAttribute(
				'data-base-country-code'
			);

			if (countryCode) {
				dpdMapWidget.options.country = countryCode;
			}

			// Set the language for the widget
			const language = dpdMapWidgetEl.getAttribute('data-language') || 'sk';
			dpdMapWidget.options.language = language;

			// Update weight and allowed locker types when opening the popup
			const minWeightInKg = parseInt(
				dpdMapOpenWidgetMapPopupEl.getAttribute('data-min-weight-in-kg')
			);
			const isEligibleForAlzabox =
				dpdMapOpenWidgetMapPopupEl.getAttribute(
					'data-is-eligible-for-alzabox'
				) === 'true';
			const isEligibleForSlovenskaPostaBox =
				dpdMapOpenWidgetMapPopupEl.getAttribute(
					'data-is-eligible-for-slovenska-posta-box'
				) === 'true';

			dpdMapWidget.options.minWeightInKg = minWeightInKg;

			const disallowShops =
				dpdMapOpenWidgetMapPopupEl.getAttribute('data-disallow-shops') ===
				'true';
			const disallowLockers =
				dpdMapOpenWidgetMapPopupEl.getAttribute('data-disallow-lockers') ===
				'true';
			const disallowDpdPickupStations =
				dpdMapOpenWidgetMapPopupEl.getAttribute(
					'data-disallow-dpd-pickup-stations'
				) === 'true';
			const disallowSkPost =
				dpdMapOpenWidgetMapPopupEl.getAttribute('data-disallow-sk-post') ===
				'true';
			const disallowAlzaBoxes =
				dpdMapOpenWidgetMapPopupEl.getAttribute('data-disallow-alza-boxes') ===
				'true';

			let allowedPudoTypes = ['shop', 'locker'];
			if (disallowShops) {
				allowedPudoTypes = allowedPudoTypes.filter((type) => type !== 'shop');
			}
			if (disallowLockers) {
				allowedPudoTypes = allowedPudoTypes.filter((type) => type !== 'locker');
			}

			dpdMapWidget.options.allowedPudoTypes = allowedPudoTypes;

			let allowedLockerTypes = [
				'dpdSkPickupStations',
				'skPost',
				'alzaSlovakia',
				'outsideOfSlovakia',
			];

			if (!isEligibleForAlzabox || !isEligibleForSlovenskaPostaBox) {
				if (!isEligibleForAlzabox) {
					allowedLockerTypes = allowedLockerTypes.filter(
						(type) => type !== 'alzaSlovakia'
					);
				}

				if (!isEligibleForSlovenskaPostaBox) {
					allowedLockerTypes = allowedLockerTypes.filter(
						(type) => type !== 'skPost'
					);
				}
			}

			if (!disallowLockers) {
				if (disallowDpdPickupStations) {
					allowedLockerTypes = allowedLockerTypes.filter(
						(type) => type !== 'dpdSkPickupStations'
					);
				}
				if (disallowSkPost) {
					allowedLockerTypes = allowedLockerTypes.filter(
						(type) => type !== 'skPost'
					);
				}
				if (disallowAlzaBoxes) {
					allowedLockerTypes = allowedLockerTypes.filter(
						(type) => type !== 'alzaSlovakia'
					);
				}
			}

			dpdMapWidget.options.allowedLockerTypes = allowedLockerTypes;

			let requiredServices = [];

			const isCodRequired =
				dpdMapOpenWidgetMapPopupEl.getAttribute('data-is-cod-required') ===
				'true';
			const isCardPaymentRequired =
				dpdMapOpenWidgetMapPopupEl.getAttribute(
					'data-is-card-payment-required'
				) === 'true';

			if (isCodRequired || isCardPaymentRequired) {
				if (isCodRequired) {
					requiredServices.push('cod');
				}

				if (isCardPaymentRequired) {
					requiredServices.push('cardPayment');
				}
			}

			dpdMapWidget.options.requiredServices = requiredServices;

			dpdMapWidget
				.attach(dpdMapWidgetEl)
				.then((pudo) => {
					setSelectedParcelShop({
						id: pudo.id,
						name: pudo.name,
						street: pudo.street,
						houseno: pudo.houseno,
						zip: pudo.zip,
						city: pudo.city,
						countryCode: pudo.countryCode,
						maxweight: pudo.maxWeightInKg,
						cod: pudo.services && pudo.services.includes('cod') ? true : false,
						card:
							pudo.services && pudo.services.includes('cardPayment')
								? true
								: false,
						isEligibleForAlzabox: isEligibleForAlzabox,
						isEligibleForSlovenskaPostaBox: isEligibleForSlovenskaPostaBox,
					});

					closePopup();
				})
				.catch((code) => {
					closePopup();
				});
		}
	}

	/**
	 * Close the popup
	 */
	function closePopup() {
		popup.classList.remove('active');

		// Check if close method exists
		if (dpdMapWidget && dpdMapWidget.close) {
			dpdMapWidget.close();
		}
	}

	/**
	 * Check if a parcel shop is chosen
	 */
	function isParcelShopChosen() {
		var chosenParcelShopId = document.querySelector(
			chosenParcelShopHiddenParcelIdSelector
		).value;
		return chosenParcelShopId !== '';
	}

	/**
	 * Get customer zip
	 */
	function getCustomerZip() {
		// Check if ship to different address is checked
		const shipToDifferentAddress = document.querySelector(
			'input[name="ship_to_different_address"]'
		);

		if (shipToDifferentAddress && shipToDifferentAddress.checked) {
			const shippingPostcodeField = document.querySelector(
				'input[name="shipping_postcode"]'
			);

			if (shippingPostcodeField) {
				customerZip = shippingPostcodeField.value;
			}

			if (customerZip) {
				return customerZip;
			}
		}

		const billingPostcodeField = document.querySelector(
			'input[name="billing_postcode"]'
		);

		if (billingPostcodeField) {
			customerZip = billingPostcodeField.value;
		}

		if (customerZip) {
			return customerZip;
		}

		customerZip = dpdMapOpenWidgetMapPopupEl.getAttribute('data-customer-zip');

		if (customerZip) {
			return customerZip;
		}

		return '';
	}

	/**
	 * Check if document is ready
	 */
	function docReady(fn) {
		if (
			document.readyState === 'complete' ||
			document.readyState === 'interactive'
		) {
			setTimeout(fn, 1);
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	}

	docReady(function () {
		init();
	});

	// Allow the functions to be called from outside
	return {
		openPopup: openPopup,
	};
})();
